import { render, staticRenderFns } from "./HomeMedico.vue?vue&type=template&id=ee23c2b4&scoped=true"
import script from "./HomeMedico.vue?vue&type=script&lang=js"
export * from "./HomeMedico.vue?vue&type=script&lang=js"
import style0 from "./HomeMedico.vue?vue&type=style&index=0&id=ee23c2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee23c2b4",
  null
  
)

export default component.exports